import React, { useState } from "react";
import {
  FormControl,
  FormControlLabel,
  RadioGroup,
  Radio,
} from "@mui/material";
import ActionList from "./ActionList";
import TopSourceActions from "./TopSourcesActions";
import MUIIconButton from "../../../../Component/UI/MUIIconButton/MUIIconButton";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import ArchiveOutlinedIcon from "@mui/icons-material/ArchiveOutlined";
import classes from "./Actions.module.css";
import { useDispatch } from "react-redux";
import {
  deleteOrArchiveActionMetric,
  fetchActionMetrics,
} from "../../../../redux/actions/metricActions";
import { AuthContext } from "../../../../context/auth-context";
import { useContext } from "react";

const ActionsView = () => {
  const [selectedValue, setSelectedValue] = useState("actions");
  const [selectedIds, setSelectedIds] = useState([]);

  const handleChange = (event) => {
    setSelectedValue(event.target.value);
  };

  const dispatch = useDispatch();
  const { user } = useContext(AuthContext);
  const customerId = user?.customer_id || 0;

  const handledeleteOrArchiveActionMetrics = (isArchived) => {
    dispatch(
      deleteOrArchiveActionMetric(customerId, 0, isArchived, selectedIds)
    ).then(() => {
      setSelectedIds([])
      dispatch(fetchActionMetrics(customerId));
    });
  };

  return (
    <>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        {" "}
        <FormControl component="fieldset">
          <RadioGroup row value={selectedValue} onChange={handleChange}>
            <FormControlLabel
              value="actions"
              control={<Radio />}
              label="Actions View"
            />
            <FormControlLabel
              value="source"
              control={<Radio />}
              label="Source View"
            />
          </RadioGroup>
        </FormControl>
        {selectedIds && selectedIds.length > 0 && (
          <div>
            <MUIIconButton
              style={{ color: "#6c757d" }}
              tooltip="Archive Selected"
              className={classes.action_btn}
              onClick={() => handledeleteOrArchiveActionMetrics(1)}
            >
              <ArchiveOutlinedIcon />
            </MUIIconButton>

            <MUIIconButton
              style={{ color: "#da1a04" }}
              tooltip="Delete Selected"
              className={classes.action_btn}
              onClick={() => handledeleteOrArchiveActionMetrics(0)}
            >
              <DeleteOutlineIcon />
            </MUIIconButton>
          </div>
        )}
      </div>

      {selectedValue === "actions" ? (
        <ActionList selectedIds={selectedIds} setSelectedIds={setSelectedIds} />
      ) : (
        <TopSourceActions />
      )}
    </>
  );
};

export default ActionsView;
